exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* hacky way to manipulate the look of the tabs */\n.tabsEditReservation .tabs-component-tabs {\n  margin-top: 0.5rem !important;\n}\n.tabsEditReservation .tabs-component-tabs, .tabsEditReservation .tabs-component-panels, .tabsEditReservation .tabs-component-panel {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.invoiceListHolder {\n  max-height: 340px;\n  overflow: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-65f300fd","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/tools/modal/ReservationEdit.vue
// module id = 1660
// module chunks = 0